/**
 * Correspondance entre les types d'entrée de chronologie et leur présentation.
 *
 * Isolé du composant pour être testable : un type d'événement ajouté côté
 * serveur mais oublié ici s'afficherait sous son nom technique, sans que rien
 * ne le signale. Le test de couverture ci-contre le détecte.
 */

export const KIND_LABELS: Record<string, string> = {
  qr_read: 'Lecture QR',
  coupling_detected: 'Détection d’attelage',
  coupled: 'Attelée',
  uncoupling_detected: 'Détection de dételage',
  uncoupled: 'Dételée',
  trailer_deposited: 'Dépose',
  device_heartbeat: 'Signal de vie du boîtier',
  gnss_lost: 'Perte du signal GNSS',
  gnss_recovered: 'Retour du signal GNSS',
  control_passage_start: 'Entrée en zone de contrôle',
  control_passage_end: 'Sortie de zone de contrôle',
  external_observation: 'Saisie opérateur',
  matching_decision: 'Décision de rapprochement',
  manual_correction: 'Correction manuelle',
};

/**
 * Groupe de couleur. Chaque SOURCE garde la sienne : c'est en les voyant
 * distinctes qu'on comprend d'où vient chaque élément d'un mouvement — et,
 * quand une décision est fausse, quelle source a menti.
 */
export const KIND_GROUPS: Record<string, string> = {
  qr_read: 'qr',
  coupling_detected: 'coupling',
  coupled: 'coupling',
  uncoupling_detected: 'coupling',
  uncoupled: 'coupling',
  trailer_deposited: 'deposit',
  gnss_lost: 'gnss',
  gnss_recovered: 'gnss',
  control_passage_start: 'control',
  control_passage_end: 'control',
  external_observation: 'external',
  matching_decision: 'decision',
  manual_correction: 'correction',
};

/** Types que le serveur peut émettre. Doit rester aligné sur admin-repository.ts. */
export const SERVER_EMITTED_KINDS = [
  'qr_read',
  'coupling_detected',
  'coupled',
  'uncoupling_detected',
  'uncoupled',
  'trailer_deposited',
  'device_heartbeat',
  'gnss_lost',
  'gnss_recovered',
  'control_passage_start',
  'control_passage_end',
  'external_observation',
  'matching_decision',
  'manual_correction',
] as const;

export function labelFor(kind: string): string {
  return KIND_LABELS[kind] ?? kind;
}

export function groupFor(kind: string): string {
  return KIND_GROUPS[kind] ?? 'other';
}
